module.exports = __webpack_public_path__ + "static/media/teaser.2b149475.png";